<ng-template #warningModal let-modal>
  <div class="modal-header" *ngIf="headerTitle">
    <!-- <img src="..." class="d-none" alt="" (error)="dModal = modal" /> -->
    <h4 class="modal-title" id="myModalLabel1">{{ headerTitle }}</h4>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="col-12 py-2">
      <h5 *ngIf="heading !== ''">{{ heading }}</h5>
      <p [innerHTML]="text"></p>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="!singleAction" type="button" class="btn btn-outline-secondary" (click)="onNo.emit()" rippleEffect
      [disabled]="noLoading || yesLoading">
      <div class="spinner-border spinner-border-sm mr-50" role="status" *ngIf="noLoading">
        <span class="sr-only">Loading...</span>
      </div>
      {{ noText }}
    </button>
    <button type="button" class="btn btn-primary" (click)="onYes.emit()" rippleEffect
      [disabled]="yesLoading || noLoading">
      <div *ngIf="yesLoading" class="spinner-border spinner-border-sm mr-50 text-white" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      {{ yesText }}
    </button>
  </div>
</ng-template>